// contextSwitchRegistry — "a workspace/account switch has fully landed" (contract 07 §8). Fired
// once per successful `SelectWorkspaceFlow.switchTo`, AFTER `finalize()`, so a listener reads the
// new workspace's hydrated state (list, RBAC, `onlyDashboard`) rather than the committed id alone.
// An account switch ends in exactly that workspace switch, so it is covered by the same signal.
//
// Same inversion as `hydratorRegistry`: 07 knows nothing about who listens. The composition root
// registers the reactions that need the router (e.g. Summary → Get Started).

export type ContextSwitchListener = () => void

const listeners = new Set<ContextSwitchListener>()

/** Subscribe to completed switches. Returns an unsubscribe fn (idempotent). */
export function onContextSwitched(listener: ContextSwitchListener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** Notify every listener. One failing listener never blocks the others or fails the switch. */
export function notifyContextSwitched(): void {
  for (const listener of [...listeners]) {
    try {
      listener()
    } catch (error: unknown) {
      console.error('[account] context-switch listener failed:', error)
    }
  }
}

/** Test seam. */
export function clearContextSwitchListeners(): void {
  listeners.clear()
}
